<div mat-dialog-content>
  <p>{{ 'DIALOG.DELETEMESS' | translate }} {{local_data.subject.firstName}} {{local_data.subject.lastName}} ({{local_data.subject.jmbg}})?</p>
</div>
<div mat-dialog-actions style="float: right;">
  <button mat-button (click)="doAction()" mat-flat-button color="primary">{{ 'DIALOG.DELETE' | translate }}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{ 'DIALOG.CANCEL' | translate }}</button>
</div>